import React from 'react';
import PropTypes from 'prop-types';

const TagPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M16.713 3.973a2.993 2.993 0 0 1 4.243.013l7.058 7.058a3.002 3.002 0 0 1 .013 4.243l-12.74 12.74a2.993 2.993 0 0 1-4.243-.013l-7.058-7.058a3.002 3.002 0 0 1-.013-4.243l12.74-12.74zm5.651 8.491a2 2 0 1 0-2.828-2.828 2 2 0 0 0 2.828 2.828z"
    />
  );
};

TagPath.propTypes = {
  fill: PropTypes.string,
};

export default TagPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/video-features/tag.jsx